<template>
  <div class="con w">
    <con-title>技术文章</con-title>
    <div class="list">
      <div class="news-box" v-for="(item, index) in articleList" :key="index" @click="toDetail(item.id)">
        <div class="news-time">
          <p>{{ item.year }}</p>
          <span>{{ item.day }}</span>
        </div>
        <div class="news-con">
          <p>{{ item.title }}</p>
          <span>{{ item.description }}</span>
        </div>
      </div>
    </div>
    <div class="page">
      <el-pagination
        :current-page.sync="listQuery.pageNo"
        :page-size="listQuery.pageSize"
        background
        layout="prev, pager, next"
        :total="total"
        @current-change="pageChange"
        @prev-click="pagePrev"
        @next-click="pageNext"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { articleList } from '@/api/article'
export default {
  data() {
    return {
      listQuery: {
        articleType: 1,
        pageNo: 1,
        pageSize: 5,
        keyword: ''
      },
      articleList: [],
      total: 0
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      var params = this.listQuery
      params.keyword = this.keyword
      const { data } = await articleList(params)
      data.page.rows.forEach(item => {
        item.year = item.createTime.substring(0, 4)
        item.day = item.createTime.substring(5, 10)
      })
      this.articleList = data.page.rows
      this.total = data.page.recordCount
    },
    toDetail(id) {
      this.$router.push({
        path: '/index/article/article-detail?id=' + id
      })
    },
    pageChange(page) {
      this.loadData()
    },
    pagePrev(page) {
      this.loadData()
    },
    pageNext(page) {
      this.loadData()
    }
  },
  computed: {
    keyword: function() {
      // `this` 指向 vm 实例
      return this.$store.state.keyword
    }
  },
  watch: {
    keyword() {
      this.loadData()
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .news-box {
    display: flex;
    width: 100%;
    background-color: #fff;
    padding: 24px;
    margin-bottom: 20px;
    position: relative;
    -webkit-transition: all 0.25s;
    -moz-transition: all 0.25s;
    -ms-transition: all 0.25s;
    -o-transition: all 0.25s;
    transition: all 0.25s;
    box-shadow: 0 0 20px 0 #eaeaea;
    .news-time {
      width: 90px;
      text-align: center;
      background: #02328d;
      padding: 10px 0;
      border-radius: 4px 0 4px 0;
      margin-right: 24px;
      p {
        font-size: 24px;
        font-weight: 700;
        color: #fff;
      }
      span {
        font-size: 14px;
        color: #fff;
      }
    }
    .news-con {
      flex: 1;
      p {
        font-size: 15px;
        font-weight: 700;
        color: #515671;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      span {
        display: block;
        font-size: 14px;
        color: #999;
        line-height: 22px;
        padding-top: 5px;
        height: 46px;
        display: -webkit-box; /*将对象转为弹性盒模型展示*/
        -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
        -webkit-line-clamp: 2; /*限制文本行数*/
        overflow: hidden; /*超出隐藏*/
      }
    }
  }

  .news-box:hover {
    background-color: #02328d;
    .news-time {
      background-color: #fff;
      p {
        color: #02328d;
      }
      span {
        color: #02328d;
      }
    }
    .news-con {
      p {
        color: #fff;
      }
      span {
        color: #fff;
      }
    }
  }
}
.page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
}
</style>
